import React from 'react'

export const ProgressIndicator = ({ currentStep, totalSteps = 2 }) => {
  return (
    <div className="flex items-center justify-center mb-6">
      <div className={`flex items-center justify-center w-8 h-8 rounded-full ${currentStep >= 1 ? 'bg-teal-500 text-white' : 'bg-gray-300'}`}>
        1
      </div>
      <div className={`w-12 sm:w-16 h-1 ${currentStep >= 2 ? 'bg-teal-500' : 'bg-gray-300'}`}></div>
      <div className={`flex items-center justify-center w-8 h-8 rounded-full ${currentStep >= 2 ? 'bg-teal-500 text-white' : 'bg-gray-300'}`}>
        2
      </div>
    </div>
  )
}